module.exports = __webpack_public_path__ + "media/images/item/reco_t-9470426c59f3c3dda79d48be6821ba1a.gif";